// extracted by mini-css-extract-plugin
export default {"metricsWrapper":"IndependentIraAssets_metricsWrapper__zg3Mv"};